import { createFileRoute } from '@tanstack/react-router'
import { VSLPage } from '@/features/vsl/VSLPage'

export const Route = createFileRoute('/_authenticated/vsl')({
  component: VSLPage,
})
